"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var PawIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PawIcon, _PureComponent);

  function PawIcon() {
    _classCallCheck(this, PawIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(PawIcon).apply(this, arguments));
  }

  _createClass(PawIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 36 31.5",
        style: {
          fill: color,
          enableBackground: 'new 0 0 63 63'
        }
      }, _react2.default.createElement("path", {
        className: "a",
        d: "M17.993,45.493c-5.583,0-13.5,8.631-13.5,14.08,0,2.454,1.885,3.92,5.044,3.92,3.434,0,5.7-1.763,8.456-1.763,2.778,0,5.052,1.763,8.456,1.763,3.159,0,5.044-1.466,5.044-3.92C31.492,54.125,23.576,45.493,17.993,45.493ZM7.637,44.607c-.731-2.436-2.984-4.014-5.031-3.525s-3.114,2.861-2.383,5.3S3.207,50.393,5.254,49.9,8.368,47.043,7.637,44.607Zm5.957-1.461c2.175-.572,3.264-3.511,2.431-6.564s-3.271-5.063-5.446-4.491S7.315,35.6,8.148,38.655,11.419,43.719,13.594,43.146Zm19.785-2.063c-2.047-.489-4.3,1.088-5.031,3.525s.335,4.808,2.383,5.3,4.3-1.088,5.031-3.525S35.426,41.572,33.379,41.083ZM22.391,43.146c2.175.572,4.614-1.438,5.446-4.491s-.256-5.991-2.431-6.564-4.614,1.438-5.446,4.491S20.216,42.573,22.391,43.146Z",
        transform: "translate(0.008 -31.993)"
      }));
    }
  }]);

  return PawIcon;
}(_react.PureComponent);

exports.default = PawIcon;